module.exports = __webpack_public_path__ + "static/6_digital_danismanlik-c21df347447c7af6165de3dfa45a0935.webp";